import React,{useState,useEffect, useRef} from 'react'
import { Form,Modal, Input,App, Radio,} from 'antd'
import { useQingqiucanshuUpdateQuery, useQingqiucanshuUpdateSaveMutation, } from '../../store/BnsKeJiApi';
import { EditOutlined } from '@ant-design/icons';
const { TextArea } = Input;
function ParamEdit(props) {   
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const onCreate = (values) => {
        setOpen(false);
    };
    const [open,setOpen] = useState()
    const [info,setInfo] = useState({
        'qqcs_et_id': props.et_id,
        'qqcs_et_name': props.et_name,
        'qqcs_type': '',
        'qqcs_require': '',
        'qqcs_uid': props.eu_id,
        'qqcs_uname': props.eu_name,
        'qqcs_id': props.qqcs_id
    });
    const {data,isSuccess} = useQingqiucanshuUpdateQuery({qqcs_id:props.qqcs_id},{skip:!open})
    const editForm = useRef();
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    qqcs_type:data.Result.qqcs_type,
                    qqcs_content:data.Result.qqcs_content,
                    qqcs_require:data.Result.qqcs_require,
                    qqcs_name:data.Result.qqcs_name,
                });
                setInfo(prevState=>({...prevState,
                    qqcs_type:data.Result.qqcs_type,
                    qqcs_content:data.Result.qqcs_content,
                    qqcs_require:data.Result.qqcs_require,    
                    qqcs_name:data.Result.qqcs_name,
                }))
            }
        }
    },[data,isSuccess])
    const [summitUpdateSave] = useQingqiucanshuUpdateSaveMutation()
    return (
        <>
            {props.eu_id===props.qqcs_uid && <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改</a>}
            <Modal
                open={open}
                title='修改接口'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                width={1000}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        }); 
                        summitUpdateSave(info).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.success('修改成功！')                                
                                setOpen(false)                         
                            }
                            if (res.data.Status === 'fail') {
                                message.error('修改失败！'+res.data.Message)
                                
                            }
                        })                           
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_module_edit_${props.qqcs_id || ''}`} // 保证唯一
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >               
                   <Form.Item name="qqcs_name" label='参数名称' wrapperCol={{span:10}} required>
                        <Input onChange={(e) => {setInfo(prevState=>({...prevState,qqcs_name:e.target.value}))}} />
                    </Form.Item> 
                    <Form.Item name="qqcs_type" label='参数类型' wrapperCol={{span:10}} required>
                        <Radio.Group onChange={(e) => {setInfo(prevState=>({...prevState,qqcs_type:e.target.value}))}}>
                            <Radio value='string'>string</Radio>
                            <Radio value='array'>array</Radio>
                        </Radio.Group> 
                    </Form.Item> 
                    
                    <Form.Item name="qqcs_require" label='是否可选' wrapperCol={{span:18}}>
                        <Radio.Group onChange={(e) => {setInfo(prevState=>({...prevState,qqcs_require:e.target.value}))}}>
                            <Radio value='必填'>必填</Radio>
                            <Radio value='可选'>可选</Radio>
                        </Radio.Group>                       
                    </Form.Item> 
                    <Form.Item name="qqcs_content" label='说明' wrapperCol={{span:18}}>
                        <TextArea 
                            onChange={(e) => {setInfo(prevState=>({...prevState,qqcs_content:e.target.value}))}}
                            rows={5}
                        />
                    </Form.Item>  
                </Form>
            </Modal>
        </>
    )
}

export default ParamEdit